import { createContext } from 'react';
import { FormInfoListProps } from './form-info-list.props';

export const FormInfoListContext = createContext<Pick<FormInfoListProps, 'type'>>({ type: 'default' });
